import React from "react";
import UserDropdown from "components/Dropdowns/UserDropdown";
import { useLocation } from "react-router-dom";

export default function Navbar() {
  const location = useLocation();

  // Fonction pour transformer l'URL en titre propre
  const getBrandText = () => {
    const path = location.pathname;

    if (path === "/admin/dashboard") return "Tableau de Bord";

    // Utilisation de startsWith pour inclure les sous-pages (register, edit, view)
    if (path.startsWith("/admin/members")) return "Gestion des Membres";
    if (path.startsWith("/admin/departments"))
      return "Gestion des Départements";
    if (path.startsWith("/admin/events")) return "Gestion des Événements";
    if (path.startsWith("/admin/attendances")) return "Gestion des Présences";
    if (path.startsWith("/admin/roles")) return "Gestion des Rôles";
    if (path.startsWith("/admin/users")) return "Gestion des Utilisateurs";
    if (path.startsWith("/admin/permissions")) return "Gestion des Permissions";
    if (path.startsWith("/admin/contribution-types"))
      return "Gestion des Types de contributions";
    if (path.startsWith("/admin/contributions"))
      return "Gestion des Contributions";
    if (path.startsWith("/admin/offerings")) return "Gestion des Offrandes";
    if (path.startsWith("/admin/expenses")) return "Gestion des Dépenses";
    if (path.startsWith("/admin/event-types"))
      return "Gestion des Types d'évenement";
    if (path.startsWith("/admin/tithes")) return "Gestion des Dîmes";
    if (path.startsWith("/admin/ecodime-classes"))
      return "Gestion des classes écodime";
    if (path.startsWith("/admin/trainings")) return "Gestion des formations";
    if (path.startsWith("/admin/member-trainings"))
      return "Gestion du suivi des formations";
    if (path.startsWith("/admin/audit-logs")) return "Pistes d'audit";
    if (path.startsWith("/admin/profile")) return "Mon Profil";
    if (path.startsWith("/admin/funds")) return "Gestion des Caisses";

    return "Administration";
  };

  return (
    <nav className="absolute bg-[#0F172A] top-0 left-0 w-full z-30 hidden md:flex md:flex-row md:flex-nowrap md:justify-start items-center p-4">
      <div className="w-full mx-auto items-center flex justify-between md:flex-nowrap flex-wrap md:px-10 px-4">
        <span className="text-white text-sm uppercase inline-block font-semibold tracking-wider">
          <i className="fas fa-layer-group mr-2 text-[#D4AF37]"></i>
          {getBrandText()}
        </span>
        <ul className="flex-col md:flex-row list-none items-center flex">
          <UserDropdown />
        </ul>
      </div>
    </nav>
  );
}
